// src/app/features/admin/services/user-management-api.service.ts

import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env';
import {
  UserListItem, UserDetail, Branch, UserListFilter,
  TwoFactorUpdateDto, TwoFactorUpdateResponse,
  SetActiveDto, SetActiveResponse,
  Bulk2FADto, Bulk2FAResponse,
  BulkSetEmailDto, BulkSetEmailResponse,
  BulkSetActiveDto, BulkSetActiveResponse,
} from '../models/admin.model';

@Injectable({ providedIn: 'root' })
export class UserManagementApiService {
  private readonly baseUrl = `${environment.apiUrl}/UserManagement`;
  private readonly http = inject(HttpClient);

  // ─── Users ──────────────────────────────────────────────────────

  getUsers(filter?: UserListFilter): Observable<UserListItem[]> {
    let params = new HttpParams();
    if (filter) {
      if (filter.active !== undefined) params = params.set('active', String(filter.active));
      if (filter.branchId !== undefined) params = params.set('branchId', String(filter.branchId));
      if (filter.twoFactorEnabled !== undefined) params = params.set('twoFactorEnabled', String(filter.twoFactorEnabled));
      if (filter.twoFactorMode !== undefined) params = params.set('twoFactorMode', String(filter.twoFactorMode));
      if (filter.q) params = params.set('q', filter.q);
    }
    return this.http.get<UserListItem[]>(`${this.baseUrl}/users`, { params });
  }

  getUser(userId: number): Observable<UserDetail> {
    return this.http.get<UserDetail>(`${this.baseUrl}/users/${userId}`);
  }

  // ─── Branches ───────────────────────────────────────────────────

  getBranches(): Observable<Branch[]> {
    return this.http.get<Branch[]>(`${this.baseUrl}/branches`);
  }

  // ─── Mutations ──────────────────────────────────────────────────

  update2FA(userId: number, dto: TwoFactorUpdateDto): Observable<TwoFactorUpdateResponse> {
    return this.http.put<TwoFactorUpdateResponse>(`${this.baseUrl}/users/${userId}/2fa`, dto);
  }

  setActive(userId: number, dto: SetActiveDto): Observable<SetActiveResponse> {
    return this.http.put<SetActiveResponse>(`${this.baseUrl}/users/${userId}/active`, dto);
  }

  // ─── Bulk ───────────────────────────────────────────────────────

  bulk2FA(dto: Bulk2FADto): Observable<Bulk2FAResponse> {
    return this.http.put<Bulk2FAResponse>(`${this.baseUrl}/bulk/2fa`, dto);
  }

  bulkSetEmail(dto: BulkSetEmailDto): Observable<BulkSetEmailResponse> {
    return this.http.put<BulkSetEmailResponse>(`${this.baseUrl}/bulk/email`, dto);
  }

  bulkSetActive(dto: BulkSetActiveDto): Observable<BulkSetActiveResponse> {
    return this.http.put<BulkSetActiveResponse>(`${this.baseUrl}/bulk/active`, dto);
  }
}
